export default __webpack_public_path__ + "static/media/ev-accommodation.6d54836f.svg";